import * as effects from 'redux-saga/effects';
import { IApplicationState } from '..';

import { Backend } from '../../Backend/Backend';
import { ICallState } from '../../Backend/Messages/callSuccess';
import { Logger } from '../../Utils/Logger';
import { saveFilters } from '../Search/Actions';
import { IUserState } from '../User/Types';

import {
    getStatisticsStep1, getStatisticsStep1Success,
    getStatisticsStep2, getStatisticsStep2Success,
    getStatisticsStep3, getStatisticsStep3Success,
    getStatisticsStep4, getStatisticsStep4Success,
    getStatisticsStep5, getStatisticsStep5Success,
    getStatsEvolutionPerMonth, getStatsEvolutionPerMonthError, getStatsEvolutionPerMonthSuccess
} from './Actions';
import {
    IStats1, IStats2, IStats3, IStats4, IStats5, IStatsActionTypes,
    IStatsFilters1, IStatsFilters2, IStatsFilters3, IStatsFilters4, IStatsFilters5,
    IStatsEvolutionFilters, IStatsEvolutionPerMonth
} from './Types';

function* handleGetStatsStep1(action: ReturnType<typeof getStatisticsStep1>) {
    const backend = Backend.getInstance();
    const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
    try {
        let filters: IStatsFilters1 = action.payload[0] as IStatsFilters1
        const res: any = yield effects.apply(backend, backend.getStatisticsStep1, [user.token, filters.mediasIds, filters.programTypesIds, filters.startDate, filters.endDate, filters.show_pres]);
        if (res.status_code === 200) {

            if (res !== null) {
                yield effects.put(getStatisticsStep1Success(res.results as IStats1[], res.total_duration_s));
                yield effects.put(saveFilters({
                    media_ids: filters.mediasIds,
                    media_str: filters.mediasStr,
                    program_types_ids: filters.programTypesIds,
                    program_types_str: filters.programTypesStr,
                    start_date: filters.startDate,
                    end_date: filters.endDate,
                }))
            }
        } else {
            Logger.warn('Failed getStatisticsStep1');
        }
    } catch (err) {
        alert(err.message)
    }
}

function* handleGetStatsStep2(action: ReturnType<typeof getStatisticsStep2>) {
    const backend = Backend.getInstance();

    try {
        let filters: IStatsFilters2 = action.payload[0] as IStatsFilters2
        const res: ICallState = yield effects.apply(backend, backend.getStatisticsStep2, [filters, action.payload[1] as any]);
        if (res.status_code === 200) {

            if (res !== null) {
                yield effects.put(getStatisticsStep2Success(res.results as IStats2[]));
            }
        } else {
            Logger.warn('Failed getStatisticsStep2');
        }
    } catch (err) {
        alert(err.message)
    }
}

function* handleGetStatsStep3(action: ReturnType<typeof getStatisticsStep3>) {
    const backend = Backend.getInstance();

    let filters: IStatsFilters3 = action.payload[0] as IStatsFilters3
    const res: ICallState = yield effects.apply(backend, backend.getStatisticsStep3, [filters]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getStatisticsStep3Success(res.results as IStats3[]));
        }
    } else {
        Logger.warn('Failed getStatisticsStep3');
    }
}

function* handleGetStatsStep4(action: ReturnType<typeof getStatisticsStep4>) {
    const backend = Backend.getInstance();

    let filters: IStatsFilters4 = action.payload[0] as IStatsFilters4
    const res: ICallState = yield effects.apply(backend, backend.getStatisticsStep4, [filters]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getStatisticsStep4Success(res.results as IStats4[]));
        }
    } else {
        Logger.warn('Failed getStatisticsStep4');
    }

}

function* handleGetStatsStep5(action: ReturnType<typeof getStatisticsStep5>) {
    const backend = Backend.getInstance();

    let filters: IStatsFilters5 = action.payload[0] as IStatsFilters5
    const res: ICallState = yield effects.apply(backend, backend.getStatisticsStep5,
        [filters]);
    if (res.status_code === 200) {

        if (res !== null) {
            yield effects.put(getStatisticsStep5Success(res.results as IStats5[]));
        }
    } else {
        Logger.warn('Failed getStatisticsStep5');
    }
}
function* handleGetStatsPerMonth(action: ReturnType<typeof getStatsEvolutionPerMonth>) {
    const backend = Backend.getInstance();
    const user: IUserState = yield effects.select((state: IApplicationState) => state.user);
    try {
        let filters: IStatsEvolutionFilters = action.payload as IStatsEvolutionFilters
        const res: ICallState = yield effects.apply(backend, backend.getStatsEvolutionPerMonth,
            [user.token, filters.year, filters.media_ids, filters.program_type_ids, filters.political_group_ids]);
        if (res.status_code === 200) {

            if (res !== null) {
                yield effects.put(getStatsEvolutionPerMonthSuccess(res.results as IStatsEvolutionPerMonth));
                yield effects.put(saveFilters({
                    media_ids: filters.media_ids,
                    media_str: filters.medias_str === undefined ? null : filters.medias_str,
                    program_types_ids: filters.program_type_ids,
                    program_types_str: filters.programs_str === undefined ? null : filters.programs_str,
                    start_date: new Date(filters.year, 0, 1),
                    end_date: new Date(filters.year, 11, 31),
                }))
            }
        } else {
            Logger.warn('Failed getStatsEvolutionPerMonth');
        }
    } catch (err) {
        Logger.warn({ err }, 'Failed getStatsEvolution');
        yield effects.put(getStatsEvolutionPerMonthError(err));
    }
}

function* watchStats() {
    yield effects.takeEvery(IStatsActionTypes.GET_STATS_STEP1, handleGetStatsStep1);
    yield effects.takeEvery(IStatsActionTypes.GET_STATS_STEP2, handleGetStatsStep2);
    yield effects.takeEvery(IStatsActionTypes.GET_STATS_STEP3, handleGetStatsStep3);
    yield effects.takeEvery(IStatsActionTypes.GET_STATS_STEP4, handleGetStatsStep4);
    yield effects.takeEvery(IStatsActionTypes.GET_STATS_STEP5, handleGetStatsStep5);
    yield effects.takeEvery(IStatsActionTypes.GET_STATS_EVOLUTION_PER_MONTH, handleGetStatsPerMonth);
}

export function* StatsSaga() {
    yield effects.all([
        effects.fork(watchStats),
    ]);
}
